export default "__VITE_ASSET__gTdvoZZp__"